/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyTaskCompletionUpdateDto
 */
export interface DailyTaskCompletionUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof DailyTaskCompletionUpdateDto
     */
    taskId: string;
    /**
     * 
     * @type {boolean}
     * @memberof DailyTaskCompletionUpdateDto
     */
    isCompleted: boolean;
}

/**
 * Check if a given object implements the DailyTaskCompletionUpdateDto interface.
 */
export function instanceOfDailyTaskCompletionUpdateDto(value: object): value is DailyTaskCompletionUpdateDto {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('isCompleted' in value) || value['isCompleted'] === undefined) return false;
    return true;
}

export function DailyTaskCompletionUpdateDtoFromJSON(json: any): DailyTaskCompletionUpdateDto {
    return DailyTaskCompletionUpdateDtoFromJSONTyped(json, false);
}

export function DailyTaskCompletionUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyTaskCompletionUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'],
        'isCompleted': json['isCompleted'],
    };
}

export function DailyTaskCompletionUpdateDtoToJSON(json: any): DailyTaskCompletionUpdateDto {
    return DailyTaskCompletionUpdateDtoToJSONTyped(json, false);
}

export function DailyTaskCompletionUpdateDtoToJSONTyped(value?: DailyTaskCompletionUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'isCompleted': value['isCompleted'],
    };
}

